import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scanid',
  templateUrl: './scanid.component.html',
  styleUrls: ['./scanid.component.scss'],
})
export class ScanidComponent implements OnInit {
  public step = 1;
  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() buttons: any;
  @Input() small: any;
  constructor(
    public router: Router
  ) { }

  ngOnInit() {}

  nextStep(){
    this.router.navigate(['/tabs/welcome-checkin/details-checkin'])
  }

  goBack(){
    window.history.back();
  }

}
